"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _default = function _default() {
  return (
    /*#__PURE__*/

    /**
    * Repeats a string (testing helper)
    *
    * @param {string} echo The string
    * @param {*} [repeat=1] Number of times to repeat the string
    * @return {Promise<radspec/evaluator/TypedValue>}
    */
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(echo) {
        var repeat,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                repeat = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
                return _context.abrupt("return", {
                  type: "string",
                  value: echo.repeat(+repeat)
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.default = _default;